// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default (admin / non-landing) navbar */

.app-nav {
  z-index: 1030;
  overflow: visible;
  border-bottom: 1px solid rgba(48, 45, 69, 0.08);
  box-shadow: 0 4px 18px rgba(48, 45, 69, 0.06);
}

.app-nav .container-fluid,
.app-nav .navbar-collapse,
.app-nav .navbar-nav,
.app-nav .nav-item,
.app-nav .dropdown,
.student-nav,
.student-nav .container-fluid,
.student-nav .navbar-collapse,
.student-nav .navbar-nav,
.student-nav .nav-item,
.student-nav .dropdown {
  overflow: visible;
}

.app-nav .navbar-toggler {
  margin-right: 0.75rem;
  border-radius: 12px !important;
  padding: 0.4rem 0.55rem;
  border: none;
}

.app-nav .navbar-nav {
  align-items: center;
  gap: 0.45rem;
}

/* —— Shared dropdown overlay: same panel language as mobile hamburger —— */

.app-nav .nav-dropdown-menu,
.student-nav .nav-dropdown-menu {
  --bs-dropdown-min-width: 12.5rem;
  --bs-dropdown-bg: #fbfbfd;
  --bs-dropdown-border-color: rgba(48, 45, 69, 0.08);
  --bs-dropdown-border-radius: 14px;
  --bs-dropdown-padding-y: 0.4rem;
  --bs-dropdown-padding-x: 0.4rem;
  --bs-dropdown-link-color: #1f1b2e;
  --bs-dropdown-link-hover-color: #1f1b2e;
  --bs-dropdown-link-hover-bg: transparent;
  --bs-dropdown-link-active-color: #1f1b2e;
  --bs-dropdown-link-active-bg: transparent;
  --bs-dropdown-zindex: 1080;

  margin-top: 0.4rem !important;
  padding: 0.4rem;
  max-height: min(70vh, 28rem);
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid rgba(48, 45, 69, 0.08);
  border-radius: 14px;
  background: #fbfbfd;
  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);
  z-index: 1080;
}

.app-nav .nav-dropdown-menu > li,
.student-nav .nav-dropdown-menu > li {
  margin: 0.15rem 0;
  overflow: visible;
}

.app-nav .nav-dropdown-menu > li:first-child,
.student-nav .nav-dropdown-menu > li:first-child {
  margin-top: 0;
}

.app-nav .nav-dropdown-menu > li:last-child,
.student-nav .nav-dropdown-menu > li:last-child {
  margin-bottom: 0;
}

/* Stacked pill chips — same feel as mobile hamburger buttons */
.app-nav .nav-dropdown-menu .dropdown-item,
.student-nav .nav-dropdown-menu .dropdown-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2.15rem;
  margin: 0;
  border: none;
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-weight: 700;
  font-size: 0.82rem;
  line-height: 1.2;
  color: #1f1b2e !important;
  background-color: #f4f2f8;
  box-shadow: none;
  text-align: center;
  transition:
    transform 0.15s ease,
    filter 0.15s ease;
}

.app-nav .nav-dropdown-menu .dropdown-item:hover,
.app-nav .nav-dropdown-menu .dropdown-item:focus,
.student-nav .nav-dropdown-menu .dropdown-item:hover,
.student-nav .nav-dropdown-menu .dropdown-item:focus {
  color: #1f1b2e !important;
  filter: brightness(0.97);
  transform: translateY(-1px);
}

.app-nav .nav-dropdown-menu .dropdown-item:active,
.student-nav .nav-dropdown-menu .dropdown-item:active {
  transform: none;
  filter: brightness(0.94);
}

.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout,
.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout {
  background-color: #d5d1fd;
}

.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout:hover,
.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout:focus,
.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout:hover,
.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout:focus {
  background-color: #d5d1fd;
  color: #1f1b2e !important;
}

/* Hero overlay: keep dropdown panel readable over dark imagery */
.student-nav--overlay .nav-dropdown-menu {
  background: rgba(251, 251, 253, 0.97);
  border-color: rgba(48, 45, 69, 0.08);
  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.16);
}

@media (max-width: 991.98px) {
  /* Match student solid hamburger panel: floating overlay, not a flat dump */
  .app-nav .navbar-collapse {
    background: rgba(251, 251, 253, 0.97);
    margin: 0.5rem 0.75rem 0;
    margin-right: 0.75rem !important;
    padding: 0.75rem 1rem 1rem;
    border-radius: 14px;
    border: 1px solid rgba(48, 45, 69, 0.08);
    box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);
    backdrop-filter: blur(14px) saturate(1.2);
    -webkit-backdrop-filter: blur(14px) saturate(1.2);
    overflow: visible;
  }

  .app-nav .navbar-nav {
    align-items: stretch;
    padding: 0.25rem 0;
  }

  .app-nav .nav-item,
  .app-nav .dropdown {
    width: 100%;
  }

  .app-nav .btn {
    width: 100%;
    margin: 0.25rem 0 !important;
  }

  /* Keep dropdowns as true floating overlays inside the hamburger panel */
  .app-nav .nav-dropdown-menu,
  .student-nav .nav-dropdown-menu {
    width: calc(100% - 1.5rem);
    max-width: 22rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;EAWE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2EAA2E;;AAE3E;;EAEE,gCAAgC;EAChC,yBAAyB;EACzB,kDAAkD;EAClD,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,0BAA0B;;EAE1B,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB;;qBAEmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,qCAAqC;EACrC,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,2EAA2E;EAC3E;IACE,qCAAqC;IACrC,wBAAwB;IACxB,gCAAgC;IAChC,0BAA0B;IAC1B,mBAAmB;IACnB,wCAAwC;IACxC,8CAA8C;IAC9C,yCAAyC;IACzC,iDAAiD;IACjD,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA,wEAAwE;EACxE;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF","sourcesContent":["/* Default (admin / non-landing) navbar */\n\n.app-nav {\n  z-index: 1030;\n  overflow: visible;\n  border-bottom: 1px solid rgba(48, 45, 69, 0.08);\n  box-shadow: 0 4px 18px rgba(48, 45, 69, 0.06);\n}\n\n.app-nav .container-fluid,\n.app-nav .navbar-collapse,\n.app-nav .navbar-nav,\n.app-nav .nav-item,\n.app-nav .dropdown,\n.student-nav,\n.student-nav .container-fluid,\n.student-nav .navbar-collapse,\n.student-nav .navbar-nav,\n.student-nav .nav-item,\n.student-nav .dropdown {\n  overflow: visible;\n}\n\n.app-nav .navbar-toggler {\n  margin-right: 0.75rem;\n  border-radius: 12px !important;\n  padding: 0.4rem 0.55rem;\n  border: none;\n}\n\n.app-nav .navbar-nav {\n  align-items: center;\n  gap: 0.45rem;\n}\n\n/* —— Shared dropdown overlay: same panel language as mobile hamburger —— */\n\n.app-nav .nav-dropdown-menu,\n.student-nav .nav-dropdown-menu {\n  --bs-dropdown-min-width: 12.5rem;\n  --bs-dropdown-bg: #fbfbfd;\n  --bs-dropdown-border-color: rgba(48, 45, 69, 0.08);\n  --bs-dropdown-border-radius: 14px;\n  --bs-dropdown-padding-y: 0.4rem;\n  --bs-dropdown-padding-x: 0.4rem;\n  --bs-dropdown-link-color: #1f1b2e;\n  --bs-dropdown-link-hover-color: #1f1b2e;\n  --bs-dropdown-link-hover-bg: transparent;\n  --bs-dropdown-link-active-color: #1f1b2e;\n  --bs-dropdown-link-active-bg: transparent;\n  --bs-dropdown-zindex: 1080;\n\n  margin-top: 0.4rem !important;\n  padding: 0.4rem;\n  max-height: min(70vh, 28rem);\n  overflow-x: hidden;\n  overflow-y: auto;\n  border: 1px solid rgba(48, 45, 69, 0.08);\n  border-radius: 14px;\n  background: #fbfbfd;\n  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);\n  z-index: 1080;\n}\n\n.app-nav .nav-dropdown-menu > li,\n.student-nav .nav-dropdown-menu > li {\n  margin: 0.15rem 0;\n  overflow: visible;\n}\n\n.app-nav .nav-dropdown-menu > li:first-child,\n.student-nav .nav-dropdown-menu > li:first-child {\n  margin-top: 0;\n}\n\n.app-nav .nav-dropdown-menu > li:last-child,\n.student-nav .nav-dropdown-menu > li:last-child {\n  margin-bottom: 0;\n}\n\n/* Stacked pill chips — same feel as mobile hamburger buttons */\n.app-nav .nav-dropdown-menu .dropdown-item,\n.student-nav .nav-dropdown-menu .dropdown-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 2.15rem;\n  margin: 0;\n  border: none;\n  border-radius: 999px;\n  padding: 0.35rem 0.9rem;\n  font-weight: 700;\n  font-size: 0.82rem;\n  line-height: 1.2;\n  color: #1f1b2e !important;\n  background-color: #f4f2f8;\n  box-shadow: none;\n  text-align: center;\n  transition:\n    transform 0.15s ease,\n    filter 0.15s ease;\n}\n\n.app-nav .nav-dropdown-menu .dropdown-item:hover,\n.app-nav .nav-dropdown-menu .dropdown-item:focus,\n.student-nav .nav-dropdown-menu .dropdown-item:hover,\n.student-nav .nav-dropdown-menu .dropdown-item:focus {\n  color: #1f1b2e !important;\n  filter: brightness(0.97);\n  transform: translateY(-1px);\n}\n\n.app-nav .nav-dropdown-menu .dropdown-item:active,\n.student-nav .nav-dropdown-menu .dropdown-item:active {\n  transform: none;\n  filter: brightness(0.94);\n}\n\n.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout,\n.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout {\n  background-color: #d5d1fd;\n}\n\n.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout:hover,\n.app-nav .nav-dropdown-menu .nav-dropdown-menu__logout:focus,\n.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout:hover,\n.student-nav .nav-dropdown-menu .nav-dropdown-menu__logout:focus {\n  background-color: #d5d1fd;\n  color: #1f1b2e !important;\n}\n\n/* Hero overlay: keep dropdown panel readable over dark imagery */\n.student-nav--overlay .nav-dropdown-menu {\n  background: rgba(251, 251, 253, 0.97);\n  border-color: rgba(48, 45, 69, 0.08);\n  box-shadow: 0 10px 28px rgba(48, 45, 69, 0.16);\n}\n\n@media (max-width: 991.98px) {\n  /* Match student solid hamburger panel: floating overlay, not a flat dump */\n  .app-nav .navbar-collapse {\n    background: rgba(251, 251, 253, 0.97);\n    margin: 0.5rem 0.75rem 0;\n    margin-right: 0.75rem !important;\n    padding: 0.75rem 1rem 1rem;\n    border-radius: 14px;\n    border: 1px solid rgba(48, 45, 69, 0.08);\n    box-shadow: 0 10px 28px rgba(48, 45, 69, 0.12);\n    backdrop-filter: blur(14px) saturate(1.2);\n    -webkit-backdrop-filter: blur(14px) saturate(1.2);\n    overflow: visible;\n  }\n\n  .app-nav .navbar-nav {\n    align-items: stretch;\n    padding: 0.25rem 0;\n  }\n\n  .app-nav .nav-item,\n  .app-nav .dropdown {\n    width: 100%;\n  }\n\n  .app-nav .btn {\n    width: 100%;\n    margin: 0.25rem 0 !important;\n  }\n\n  /* Keep dropdowns as true floating overlays inside the hamburger panel */\n  .app-nav .nav-dropdown-menu,\n  .student-nav .nav-dropdown-menu {\n    width: calc(100% - 1.5rem);\n    max-width: 22rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
